module.exports = __webpack_public_path__ + "static/media/report.2a4fab8a.png";